"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _DropdownMenu = _interopRequireDefault(require("../DropdownMenu"));
var _GuestMenu = _interopRequireDefault(require("../GuestMenu"));
var _index = _interopRequireDefault(require("./index.style"));
const InlineMenu = props => {
  const {
    menuData,
    className,
    selectedOption = () => {},
    selectedGuests = () => {},
    disabled = false,
    ...others
  } = props;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_Grid.default, (0, _extends2.default)({}, others, {
    className: classes.inlineMenuWrapper,
    item: true,
    xs: 12
  }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: (0, _clsx.default)(classes.inlineMenu, className)
  }, menuData.map(menu => {
    if (menu.type === 'dropDown') {
      return /*#__PURE__*/_react.default.createElement(_DropdownMenu.default, {
        key: menu.id,
        id: menu.id,
        onSelectedOption: selectedOption,
        disabled: menu.disabled,
        menuItems: menu.items
      });
    }
    return /*#__PURE__*/_react.default.createElement(_GuestMenu.default, {
      disabled: disabled,
      key: menu.id,
      id: menu.id,
      onChoseDone: selectedGuests,
      labelMenu: menu.labelMenu,
      labelCancel: menu.labelCancel,
      labelDone: menu.labelDone,
      labelOnLapNote: menu.labelOnLapNote,
      unaccompaniedMinorError: menu.unaccompaniedMinorError,
      minAgeToTravelAlone: menu.minAgeToTravelAlone,
      minAgeToAccompanyMinors: menu.minAgeToAccompanyMinors,
      menuItems: menu.items
    });
  })));
};
var _default = exports.default = InlineMenu;